import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import styled from './styled';
const { styleTablet, crossbtn, mainContiner, tabContainer } = styled;
let timeout = null;

const MultiTextInputBox = ({ onUpdate, placeholder = "", defaultValue = [] }) => {

   const [collectInputs, setCollectInputs] = useState(defaultValue)
   const [value, setValue] = useState(null);
   const inputRef = useRef('inputRef');

   useEffect(() => {
      onUpdate(collectInputs);
   }, [collectInputs])

   const onRemoveTablet = (index) => () => {
      const clone = Object.assign([], collectInputs);
      clone?.splice(index, 1);
      setCollectInputs(clone);
   };

   const tablet = (v, i) => (<span key={i} style={styleTablet}>
      <div style={{ padding: '0 5px' }}> {v}</div>
      <div onClick={onRemoveTablet(i)} style={crossbtn}>X</div>
   </span>);


   const handelOnPressEnter = ({ target }) => {
      if (!Boolean(target?.value)) return
      setCollectInputs((prev) => ([...prev, target?.value]))
      setTimeout(setValue(null), 20);
   }

   const handleOnChange = ({ target }) => {
      setValue(target?.value);
      clearTimeout(timeout);

      timeout = setTimeout(() => {
         handelOnPressEnter({target})
      }, 1000);

   }

   const handelOnBackspace = (args) => {

      if (args?.keyCode === 8 && Boolean(collectInputs.length) && !value) {
         const clone = Object.assign([], collectInputs);
         clone?.pop();
         setCollectInputs(clone);
      }
   }

   const handelOnPaste = (target) => {
      handelOnPressEnter({target})
   }

   const onClickThisDiv = () => {
      inputRef?.current?.focus();
   }

   return (<>
      <div style={mainContiner} onClick={onClickThisDiv}>
         <div style={tabContainer}> {collectInputs?.map((v, i) => tablet(v, i))}
            <Input
               style={{ width: `${(value?.length + 3) * 8}px`, alignSelf: 'flex-end', fontSize: '1.2em' }}
               ref={inputRef}
               bordered={false}
               placeholder={!(collectInputs?.length) ? placeholder : ""}
               value={value}
               onChange={handleOnChange}
               onKeyDown={handelOnBackspace}
               onPressEnter={handelOnPressEnter}
               onPaste={handelOnPaste}
            />
         </div>
      </div>
   </>
   )
}

MultiTextInputBox.propTypes = {
   onUpdate: PropTypes.func,
   placeholder: PropTypes.string,
   defaultValue: PropTypes.array
}

export default MultiTextInputBox
